/// <reference path="../interfaces/lightsliderconfig.ts" />
module Tapas.ViewModels {
    export class NewsViewModel extends Ftw.ViewModels.BaseViewModel {
		public data = new Ftw.Data;
        public newsDetailHtml = ko.observable("");

        constructor() {
            super();
        }

		public newsModal = (url, selector) => {

			this.data.get(url + "&LayoutTemplate=Designs/Tapas/ajax_page.cshtml&ajaxTapas=true")
			.then((data) => {
				this.newsDetailHtml($(data).html());
				$(selector).modal();
			});
		}
    }
}

